/**
 * Get Grid select person list based on a persons object array
 * @param {Array} Array of person Objects
 * @returns {Array}
 */
const getGridSelectPersonList = function ({ persons }) {
  const personList = []

  persons.forEach((person) => {
    if (!personList.includes(person.name)) {
      personList.push({
        description: person.name,
        value: person.name,
        dimensionObjectID: person.dimensionObjectID,
      })
    }
  })

  return personList
}

export { getGridSelectPersonList }
